// extracted by mini-css-extract-plugin
module.exports = {"entry":"_1OU4K","icon":"_1A1c4","title":"_191Gw"};